import React, { ChangeEvent, FC, useCallback } from 'react';
import { Box } from '@src/atoms/Box';
import { IOption, ISizeProps, IWithStylesProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import styled from './RadioButtonOption.scss';
import { IRadioButtonProps } from '@src/atoms/RadioButton/models';

interface IRadioButtonOptionProps extends IOption, IWithStylesProps, ISizeProps, Pick<IRadioButtonProps, 'view'> {
  /** Выбрана ли опция */
  checked?: boolean;

  /** Заблокирована ли опция */
  disabled?: boolean;

  /** Обработчик изменения значения */
  onChange: (v: string) => void;

  /** Id родительского элемента */
  radioGroupId: string;
}

export const RadioButtonOption: FC<IRadioButtonOptionProps> = ({
  label,
  value,
  checked,
  disabled,
  className,
  style,
  onChange,
  view = 'default',
  radioGroupId,
}) => {
  const classes = classnames(styled.root, className, {
    [styled.disabled]: disabled,
  });
  const labelClass = classnames(styled.label, styled[view]);
  const id = `${radioGroupId}_option_${value}`;

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value);
    },
    [onChange],
  );

  return (
    <Box alignItems={'center'} className={classes} style={style}>
      <input
        type="radio"
        className={styled.input}
        id={value}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        data-id={id}
        name={radioGroupId}
      />
      <label htmlFor={value} className={labelClass}>
        {label}
      </label>
    </Box>
  );
};
